import {
  emptyStateBodyVariants,
  emptyStateContentVariants,
  emptyStateHeadingVariants,
} from '~/components/component-library/EmptyState/styles'
import { type EmptyStateProps } from '~/components/component-library/EmptyState/types'
import { cn } from '~/utils/tailwind-utils'

export { type EmptyStateProps } from '~/components/component-library/EmptyState/types'

export const EmptyState = ({
  children,
  icon,
  title,
  headingLevel = 2,
  size = 'default',
  textSize,
  fullScreen = false,
  className = '',
}: EmptyStateProps) => {
  const Heading = `h${headingLevel}` as const
  const bodyTextSize = textSize ?? (size === 'compact' ? 'sm' : 'inherit')

  return (
    <div
      className={cn(
        'flex w-full flex-col justify-center rounded-lg bg-surface-hover text-primary',
        { 'bg-transparent': fullScreen },
        className,
      )}
    >
      <div className={cn(emptyStateContentVariants({ size }))}>
        {icon && (
          <div
            aria-hidden="true"
            className="mb-4 flex justify-center text-secondary"
          >
            {icon}
          </div>
        )}
        {title && (
          <Heading className={cn(emptyStateHeadingVariants({ size }))}>
            {title}
          </Heading>
        )}
        <div
          className={cn(
            'w-full space-y-4 text-balance break-words text-center text-secondary',
            emptyStateBodyVariants({ textSize: bodyTextSize }),
          )}
        >
          {children}
        </div>
      </div>
    </div>
  )
}
